module.exports = __webpack_public_path__ + "img/error-accessories.6bc8cbef.svg";